import { useCallback, useEffect, useState } from 'react';
import {
  SPONSOR_PROTOCOL_LINK,
  PARTICIPANTS_PROTOCOL_LINK,
} from '@component/Layout/CustomFooter/data';

// 协议相关逻辑，pc移动通用
const useProtocol = () => {
  const [isAgree, setIsAgree] = useState(false); // 是否已同意协议
  const [protocolList, setProtocolList] = useState<
    {
      name: string;
      url: string;
    }[]
  >([]);

  useEffect(() => {
    // 放在这是为了避免window报不存在的错
    setProtocolList([
      {
        name: '腾讯会议活动发起者注册协议',
        url: `${window?.location?.origin}${SPONSOR_PROTOCOL_LINK}`,
      },
      {
        name: '腾讯会议参会者服务协议',
        url: `${window?.location?.origin}${PARTICIPANTS_PROTOCOL_LINK}`,
      },
    ]);
  }, []);

  // 切换
  const changeAgree = useCallback((val: boolean) => {
    setIsAgree(val);
  }, []);

  return {
    isAgree,
    changeAgree,
    protocolList,
  };
};

export default useProtocol;
